export default {
  root: {
    class: [
      // Shape
      'rounded-md',

      // Size
      'min-w-[12rem]',
      'py-1',

      // Colors
      'bg-secondary-0 dark:bg-secondary-700',
      'border border-secondary-200 dark:border-secondary-700'
    ]
  },
  menu: {
    class: [
      // Spacings and Shape
      'list-none',
      'm-0',
      'p-0',
      'outline-none'
    ]
  },
  menuitem: {
    class: [
      // Position
      'relative'
    ]
  },
  content: ({ context }) => ({
    class: [
      //Shape
      'rounded-none',

      //  Colors
      {
        'text-secondary-500 dark:text-white/70': !context.focused && !context.active,
        'text-secondary-500 dark:text-white/70 bg-secondary-200 dark:bg-secondary-600/90':
          context.focused && !context.active,
        'text-primary-700 dark:text-secondary-0/80 bg-primary-50 dark:bg-primary-400/30':
          context.focused && context.active,
        'text-primary-700 dark:text-secondary-0/80 bg-primary-50 dark:bg-primary-400/30':
          !context.focused && context.active
      },

      // Hover States
      {
        'hover:bg-secondary-100 dark:hover:bg-secondary-600/80': !context.active,
        'hover:bg-primary-500/50 dark:hover:bg-primary-300/30 text-primary-700 dark:text-secondary-0/80': context.active
      },

      // Transitions
      'transition-shadow',
      'duration-200'
    ]
  }),
  action: {
    class: [
      'relative',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      'py-2',
      'px-3',

      // Color
      'text-secondary-700 dark:text-white/80',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none'
    ]
  },
  icon: {
    class: [
      // Spacing
      'mr-2',

      // Color
      'text-secondary-600 dark:text-white/70'
    ]
  },
  label: {
    class: ['leading-none']
  },
  submenuicon: {
    class: [
      // Position
      'ml-auto'
    ]
  },
  submenu: {
    class: [
      // Size
      'w-full sm:w-48',

      // Spacing
      'py-1',
      'm-0',
      'list-none',

      // Shape
      'shadow-none sm:shadow-md',
      'border-0',

      // Position
      'static sm:absolute',
      'z-10',

      // Color
      'bg-secondary-0 dark:bg-secondary-700'
    ]
  },
  separator: {
    class: 'border-t border-secondary-200 dark:border-secondary-600 my-1'
  }
};
